// AUTO-GENERATED from variants/variants.json — do not edit manually.
// Run `pnpm codegen:variants` to regenerate.

import { GameVariant } from '../types/enums.js';

export type VariantCode = 'int' | 'ita' | 'eng' | 'bra' | 'fri' | 'frk' | 'tur' | 'arm' | 'rus' | 'spa' | 'tri' | 'can' | 'nig' | 'gha' | 'hex' | 'pol' | 'cze' | 'tha' | 'por' | 'phi' | 'mly' | 'ger' | 'jam' | 'sri' | 'rsa' | 'dme' | 'cro';
export type VariantShape = 'square' | 'hex';
export type VariantMovement = 'diagonal' | 'orthogonal';
export type VariantCaptureType = 'diagonal' | 'orthogonal' | 'mixed';
export type VariantWinCondition = 'normal' | 'suicide';
export type VariantPlayableSquares = 'dark' | 'all';
export type VariantStartingColor = 'W' | 'B';

export interface VariantBoardSpec {
  shape: VariantShape;
  size: number;
  playableSquares: VariantPlayableSquares;
  piecesPerPlayer: number;
  initialFen: string;
  initialWhite: readonly number[];
  initialBlack: readonly number[];
  initialKingsWhite: readonly number[];
  initialKingsBlack: readonly number[];
  startingColor: VariantStartingColor;
  blackStarts: boolean;
}

export type VariantCaptureCompareStrategy = 'none' | 'maxPieces' | 'maxValue' | 'maxWithKings';

export interface VariantRulesSpec {
  movement: VariantMovement;
  captureType: VariantCaptureType;
  winCondition: VariantWinCondition;
  flyingKings: boolean;
  menCaptureBackward: boolean;
  menCanCaptureKing: boolean;
  mustCaptureMaximum: boolean;
  captureCompareStrategy: VariantCaptureCompareStrategy;
  preferKingCaptureOnTie: boolean;
  compareCaptureSequence: boolean;
  manCaptureValue: number;
  kingCaptureValue: number;
  huffing: boolean;
  promotionStopsCapture: boolean;
  drawMoveLimit: number;
  /** Frisian 'blocked king' rule: max consecutive non-capture moves a lone king may make before the player must move another piece. 0 = disabled. */
  blockedKingMaxMoves: number;
  /** Enables Frisian material draw rules (2-kings-vs-1-king 7-move draw, king-vs-king auto-draw). */
  frisianEndgameDraws: boolean;
  /** Russian/Pool 'promotion in passing': a man that reaches the back rank mid-capture becomes a
   * king immediately and continues the capture as a flying king. Only meaningful when
   * promotionStopsCapture is false. Default false (International/Brazilian: it stays a man). */
  promoteInPassing: boolean;
  /** Captured pieces are removed from the board immediately during the capture sequence
   * (Turkish/Triestine), so later jumps may pass over or land on their squares. Default false:
   * captured pieces stay as blockers until the move ends (coup turc). */
  removesCapturedImmediately: boolean;
  /** Turkish rule: within a multi-capture, the piece may continue straight or turn 90° but may
   * not reverse 180° between two jumps. In practice only kings are affected (men cannot reverse
   * geometrically). Default false. */
  forbidCaptureReversal: boolean;
  /** Turkish endgame adjudication: a lone king versus a lone man is an immediate win for the
   * king's side (the game is not dragged out). Default false. */
  loneKingVsLoneManWins: boolean;
  /** Ghanaian rule: a player left with a single piece (man or king) loses immediately.
   * Default false. */
  singlePieceLoses: boolean;
}

/** Default per-variant board/piece colors, applied when the user's theme preference is 'auto'. */
export interface VariantColors {
  darkSquare: string;
  lightSquare: string;
  whitePiece: string;
  blackPiece: string;
}

export interface VariantUiSpec {
  darkSquareBottomRight: boolean;
  flagEmoji: string;
  labelKey: string;
  colors: VariantColors;
}

export interface VariantSpec {
  code: VariantCode;
  variant: GameVariant;
  cppType: string | null;
  experimental: boolean;
  board: VariantBoardSpec;
  rules: VariantRulesSpec;
  ui: VariantUiSpec;
}

/**
 * Master Matrix: variants enumerated in /variants/variants.jsonc.
 * Keys: INTERNATIONAL, ITALIAN, ENGLISH, BRAZILIAN, FRISIAN, FRYSK, TURKISH, ARMENIAN, RUSSIAN, SPANISH, TRIESTINE, CANADIAN, NIGERIAN, GHANAIAN, HEX, POOL, CZECH, THAI, PORTUGUESE, FILIPINO, MALAYSIAN, GERMAN, JAMAICAN, SINHALESE, SOUTH_AFRICAN, DAMEO, CRODA
 */
export const VARIANT_SPECS: Record<GameVariant, VariantSpec> = {
  [GameVariant.INTERNATIONAL]: {
    code: "int",
    variant: GameVariant.INTERNATIONAL,
    cppType: "International",
    experimental: false,
    board: {
    shape: "square",
    size: 10,
    playableSquares: "dark",
    piecesPerPlayer: 20,
    initialFen: "W:W31-50:B1-20",
    initialWhite: [31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: true,
    menCanCaptureKing: true,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxPieces",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 50,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🌍",
    labelKey: "variants.int",
    colors: {
      darkSquare: "#B58863",
      lightSquare: "#F0D9B5",
      whitePiece: "#F5ECD9",
      blackPiece: "#2E2A26",
    },
    },
  },
  [GameVariant.ITALIAN]: {
    code: "ita",
    variant: GameVariant.ITALIAN,
    cppType: "Italian",
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "dark",
    piecesPerPlayer: 12,
    initialFen: "W:W21-32:B1-12",
    initialWhite: [21,22,23,24,25,26,27,28,29,30,31,32],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: false,
    menCaptureBackward: false,
    menCanCaptureKing: false,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxWithKings",
    preferKingCaptureOnTie: true,
    compareCaptureSequence: true,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: true,
    drawMoveLimit: 80,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: true,
    flagEmoji: "🇮🇹",
    labelKey: "variants.ita",
    colors: {
      darkSquare: "#C06415",
      lightSquare: "#F1F1F1",
      whitePiece: "#DDB73D",
      blackPiece: "#593E12",
    },
    },
  },
  [GameVariant.ENGLISH]: {
    code: "eng",
    variant: GameVariant.ENGLISH,
    cppType: "English",
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "dark",
    piecesPerPlayer: 12,
    initialFen: "B:W21-32:B1-12",
    initialWhite: [21,22,23,24,25,26,27,28,29,30,31,32],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "B",
    blackStarts: true,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: false,
    menCaptureBackward: false,
    menCanCaptureKing: true,
    mustCaptureMaximum: false,
    captureCompareStrategy: "none",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: true,
    drawMoveLimit: 80,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇬🇧",
    labelKey: "variants.eng",
    colors: {
      darkSquare: "#4E7A3F",
      lightSquare: "#E8E2C8",
      whitePiece: "#E6CF9C",
      blackPiece: "#C2392B",
    },
    },
  },
  [GameVariant.BRAZILIAN]: {
    code: "bra",
    variant: GameVariant.BRAZILIAN,
    cppType: "Brazilian",
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "dark",
    piecesPerPlayer: 12,
    initialFen: "W:W21-32:B1-12",
    initialWhite: [21,22,23,24,25,26,27,28,29,30,31,32],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: true,
    menCanCaptureKing: true,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxPieces",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 50,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇧🇷",
    labelKey: "variants.bra",
    colors: {
      darkSquare: "#3E7D4F",
      lightSquare: "#EEDFA8",
      whitePiece: "#F4EFD8",
      blackPiece: "#23281F",
    },
    },
  },
  [GameVariant.FRISIAN]: {
    code: "fri",
    variant: GameVariant.FRISIAN,
    cppType: "Frisian",
    experimental: false,
    board: {
    shape: "square",
    size: 10,
    playableSquares: "dark",
    piecesPerPlayer: 20,
    initialFen: "W:W31-50:B1-20",
    initialWhite: [31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "mixed",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: true,
    menCanCaptureKing: true,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxValue",
    preferKingCaptureOnTie: true,
    compareCaptureSequence: false,
    manCaptureValue: 100,
    kingCaptureValue: 199,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 3,
    frisianEndgameDraws: true,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇳🇱",
    labelKey: "variants.fri",
    colors: {
      darkSquare: "#3F6F7A",
      lightSquare: "#EFE0C0",
      whitePiece: "#F5EFE0",
      blackPiece: "#222831",
    },
    },
  },
  [GameVariant.FRYSK]: {
    code: "frk",
    variant: GameVariant.FRYSK,
    cppType: "Frysk",
    experimental: false,
    board: {
    shape: "square",
    size: 10,
    playableSquares: "dark",
    piecesPerPlayer: 5,
    initialFen: "W:W46-50:B1-5",
    initialWhite: [46,47,48,49,50],
    initialBlack: [1,2,3,4,5],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "mixed",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: true,
    menCanCaptureKing: true,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxValue",
    preferKingCaptureOnTie: true,
    compareCaptureSequence: false,
    manCaptureValue: 100,
    kingCaptureValue: 199,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 3,
    frisianEndgameDraws: true,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇳🇱",
    labelKey: "variants.frk",
    colors: {
      darkSquare: "#4E8A86",
      lightSquare: "#F1E6CC",
      whitePiece: "#F6F0E2",
      blackPiece: "#20302E",
    },
    },
  },
  [GameVariant.TURKISH]: {
    code: "tur",
    variant: GameVariant.TURKISH,
    cppType: "Turkish",
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "all",
    piecesPerPlayer: 16,
    initialFen: "W:W41-56:B9-24",
    initialWhite: [41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56],
    initialBlack: [9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "orthogonal",
    captureType: "orthogonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: false,
    menCanCaptureKing: true,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxPieces",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: true,
    forbidCaptureReversal: true,
    loneKingVsLoneManWins: true,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇹🇷",
    labelKey: "variants.tur",
    colors: {
      darkSquare: "#9A463D",
      lightSquare: "#E6E0CC",
      whitePiece: "#F3EEE0",
      blackPiece: "#26211B",
    },
    },
  },
  [GameVariant.ARMENIAN]: {
    code: "arm",
    variant: GameVariant.ARMENIAN,
    cppType: null,
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "all",
    piecesPerPlayer: 16,
    initialFen: "W:W41-56:B9-24",
    initialWhite: [41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56],
    initialBlack: [9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "orthogonal",
    captureType: "mixed",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: false,
    menCanCaptureKing: true,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxPieces",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: true,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇦🇲",
    labelKey: "variants.arm",
    colors: {
      darkSquare: "#B06A2C",
      lightSquare: "#EFDDB2",
      whitePiece: "#F5ECD4",
      blackPiece: "#2C2418",
    },
    },
  },
  [GameVariant.RUSSIAN]: {
    code: "rus",
    variant: GameVariant.RUSSIAN,
    cppType: "Russian",
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "dark",
    piecesPerPlayer: 12,
    initialFen: "W:W21-32:B1-12",
    initialWhite: [21,22,23,24,25,26,27,28,29,30,31,32],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: true,
    menCanCaptureKing: true,
    mustCaptureMaximum: false,
    captureCompareStrategy: "none",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 30,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: true,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇷🇺",
    labelKey: "variants.rus",
    colors: {
      darkSquare: "#9C6B3F",
      lightSquare: "#EBD3A8",
      whitePiece: "#F4ECDB",
      blackPiece: "#34281C",
    },
    },
  },
  [GameVariant.SPANISH]: {
    code: "spa",
    variant: GameVariant.SPANISH,
    cppType: "Spanish",
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "dark",
    piecesPerPlayer: 12,
    initialFen: "W:W21-32:B1-12",
    initialWhite: [21,22,23,24,25,26,27,28,29,30,31,32],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: false,
    menCanCaptureKing: true,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxWithKings",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: true,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: true,
    flagEmoji: "🇪🇸",
    labelKey: "variants.spa",
    colors: {
      darkSquare: "#A85C2E",
      lightSquare: "#EFD9A6",
      whitePiece: "#F5ECD6",
      blackPiece: "#2E241C",
    },
    },
  },
  [GameVariant.TRIESTINE]: {
    code: "tri",
    variant: GameVariant.TRIESTINE,
    cppType: "Triestine",
    experimental: false,
    board: {
    shape: "square",
    size: 10,
    playableSquares: "dark",
    piecesPerPlayer: 20,
    initialFen: "W:W31-50:B1-20",
    initialWhite: [31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: false,
    menCaptureBackward: false,
    menCanCaptureKing: false,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxWithKings",
    preferKingCaptureOnTie: true,
    compareCaptureSequence: true,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: true,
    drawMoveLimit: 80,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: true,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: true,
    flagEmoji: "🇮🇹",
    labelKey: "variants.tri",
    colors: {
      darkSquare: "#A95712",
      lightSquare: "#F1F1F1",
      whitePiece: "#DDB73D",
      blackPiece: "#593E12",
    },
    },
  },
  [GameVariant.CANADIAN]: {
    code: "can",
    variant: GameVariant.CANADIAN,
    cppType: "Canadian",
    experimental: false,
    board: {
    shape: "square",
    size: 12,
    playableSquares: "dark",
    piecesPerPlayer: 30,
    initialFen: "W:W43-72:B1-30",
    initialWhite: [43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: true,
    menCanCaptureKing: true,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxPieces",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 50,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇨🇦",
    labelKey: "variants.can",
    colors: {
      darkSquare: "#8A4B3A",
      lightSquare: "#ECDCC0",
      whitePiece: "#F4ECD9",
      blackPiece: "#2B231E",
    },
    },
  },
  [GameVariant.NIGERIAN]: {
    code: "nig",
    variant: GameVariant.NIGERIAN,
    cppType: "Nigerian",
    experimental: false,
    board: {
    shape: "square",
    size: 10,
    playableSquares: "dark",
    piecesPerPlayer: 20,
    initialFen: "W:W31-50:B1-20",
    initialWhite: [31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: true,
    menCanCaptureKing: true,
    mustCaptureMaximum: false,
    captureCompareStrategy: "none",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 50,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: true,
    flagEmoji: "🇳🇬",
    labelKey: "variants.nig",
    colors: {
      darkSquare: "#2F7A4F",
      lightSquare: "#E7E4C8",
      whitePiece: "#F2EEDC",
      blackPiece: "#20271F",
    },
    },
  },
  [GameVariant.GHANAIAN]: {
    code: "gha",
    variant: GameVariant.GHANAIAN,
    cppType: "Ghanaian",
    experimental: false,
    board: {
    shape: "square",
    size: 10,
    playableSquares: "dark",
    piecesPerPlayer: 20,
    initialFen: "W:W31-50:B1-20",
    initialWhite: [31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: true,
    menCanCaptureKing: true,
    mustCaptureMaximum: false,
    captureCompareStrategy: "none",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 50,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: true,
    },
    ui: {
    darkSquareBottomRight: true,
    flagEmoji: "🇬🇭",
    labelKey: "variants.gha",
    colors: {
      darkSquare: "#8C6A2E",
      lightSquare: "#ECD9A6",
      whitePiece: "#F3EAD2",
      blackPiece: "#2C2618",
    },
    },
  },
  [GameVariant.HEX]: {
    code: "hex",
    variant: GameVariant.HEX,
    cppType: null,
    experimental: true,
    board: {
    shape: "hex",
    size: 7,
    playableSquares: "all",
    piecesPerPlayer: 0,
    initialFen: "W::B",
    initialWhite: [],
    initialBlack: [],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: true,
    menCanCaptureKing: true,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxPieces",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "⬡",
    labelKey: "variants.hex",
    colors: {
      darkSquare: "#5E7C78",
      lightSquare: "#DCE3E0",
      whitePiece: "#F0F2F0",
      blackPiece: "#232A28",
    },
    },
  },
  [GameVariant.POOL]: {
    code: "pol",
    variant: GameVariant.POOL,
    cppType: "Pool",
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "dark",
    piecesPerPlayer: 12,
    initialFen: "B:W21-32:B1-12",
    initialWhite: [21,22,23,24,25,26,27,28,29,30,31,32],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "B",
    blackStarts: true,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: true,
    menCanCaptureKing: true,
    mustCaptureMaximum: false,
    captureCompareStrategy: "none",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇺🇸",
    labelKey: "variants.pol",
    colors: {
      darkSquare: "#3A567A",
      lightSquare: "#E4E2D2",
      whitePiece: "#F2EFE2",
      blackPiece: "#1F242C",
    },
    },
  },
  [GameVariant.CZECH]: {
    code: "cze",
    variant: GameVariant.CZECH,
    cppType: null,
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "dark",
    piecesPerPlayer: 12,
    initialFen: "W:W21-32:B1-12",
    initialWhite: [21,22,23,24,25,26,27,28,29,30,31,32],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: false,
    menCanCaptureKing: true,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxPieces",
    preferKingCaptureOnTie: true,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇨🇿",
    labelKey: "variants.cze",
    colors: {
      darkSquare: "#5A6B86",
      lightSquare: "#E0E3E8",
      whitePiece: "#F2F1EC",
      blackPiece: "#232730",
    },
    },
  },
  [GameVariant.THAI]: {
    code: "tha",
    variant: GameVariant.THAI,
    cppType: null,
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "dark",
    piecesPerPlayer: 8,
    initialFen: "W:W25-32:B1-8",
    initialWhite: [25,26,27,28,29,30,31,32],
    initialBlack: [1,2,3,4,5,6,7,8],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: false,
    menCanCaptureKing: true,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxPieces",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇹🇭",
    labelKey: "variants.tha",
    colors: {
      darkSquare: "#7A4A2C",
      lightSquare: "#ECDCB0",
      whitePiece: "#F4E9CE",
      blackPiece: "#2E2218",
    },
    },
  },
  [GameVariant.PORTUGUESE]: {
    code: "por",
    variant: GameVariant.PORTUGUESE,
    cppType: null,
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "dark",
    piecesPerPlayer: 12,
    initialFen: "W:W21-32:B1-12",
    initialWhite: [21,22,23,24,25,26,27,28,29,30,31,32],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: false,
    menCanCaptureKing: true,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxWithKings",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇵🇹",
    labelKey: "variants.por",
    colors: {
      darkSquare: "#3A6B4A",
      lightSquare: "#E7E0C4",
      whitePiece: "#F2ECD6",
      blackPiece: "#232A20",
    },
    },
  },
  [GameVariant.FILIPINO]: {
    code: "phi",
    variant: GameVariant.FILIPINO,
    cppType: null,
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "dark",
    piecesPerPlayer: 12,
    initialFen: "W:W21-32:B1-12",
    initialWhite: [21,22,23,24,25,26,27,28,29,30,31,32],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: false,
    menCaptureBackward: true,
    menCanCaptureKing: true,
    mustCaptureMaximum: false,
    captureCompareStrategy: "none",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: true,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇵🇭",
    labelKey: "variants.phi",
    colors: {
      darkSquare: "#34518C",
      lightSquare: "#E5E5DA",
      whitePiece: "#F2F0E6",
      blackPiece: "#20232B",
    },
    },
  },
  [GameVariant.MALAYSIAN]: {
    code: "mly",
    variant: GameVariant.MALAYSIAN,
    cppType: null,
    experimental: false,
    board: {
    shape: "square",
    size: 12,
    playableSquares: "dark",
    piecesPerPlayer: 24,
    initialFen: "W:W49-72:B1-24",
    initialWhite: [49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: false,
    menCanCaptureKing: true,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxPieces",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇲🇾",
    labelKey: "variants.mly",
    colors: {
      darkSquare: "#2E6B86",
      lightSquare: "#E8E6D2",
      whitePiece: "#F3EFDF",
      blackPiece: "#1F2A2E",
    },
    },
  },
  [GameVariant.GERMAN]: {
    code: "ger",
    variant: GameVariant.GERMAN,
    cppType: null,
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "dark",
    piecesPerPlayer: 12,
    initialFen: "W:W21-32:B1-12",
    initialWhite: [21,22,23,24,25,26,27,28,29,30,31,32],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: true,
    menCanCaptureKing: true,
    mustCaptureMaximum: false,
    captureCompareStrategy: "none",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇩🇪",
    labelKey: "variants.ger",
    colors: {
      darkSquare: "#4A4742",
      lightSquare: "#E4E0D2",
      whitePiece: "#F2EEE0",
      blackPiece: "#1A1A1A",
    },
    },
  },
  [GameVariant.JAMAICAN]: {
    code: "jam",
    variant: GameVariant.JAMAICAN,
    cppType: null,
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "dark",
    piecesPerPlayer: 12,
    initialFen: "B:W21-32:B1-12",
    initialWhite: [21,22,23,24,25,26,27,28,29,30,31,32],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "B",
    blackStarts: true,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: true,
    menCanCaptureKing: true,
    mustCaptureMaximum: false,
    captureCompareStrategy: "none",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: true,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇯🇲",
    labelKey: "variants.jam",
    colors: {
      darkSquare: "#2E7A46",
      lightSquare: "#EDE6BE",
      whitePiece: "#F4EFCE",
      blackPiece: "#1C1C1C",
    },
    },
  },
  [GameVariant.SINHALESE]: {
    code: "sri",
    variant: GameVariant.SINHALESE,
    cppType: null,
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "dark",
    piecesPerPlayer: 12,
    initialFen: "W:W21-32:B1-12",
    initialWhite: [21,22,23,24,25,26,27,28,29,30,31,32],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: false,
    menCanCaptureKing: true,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxPieces",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇱🇰",
    labelKey: "variants.sri",
    colors: {
      darkSquare: "#8A3A3A",
      lightSquare: "#ECDDC0",
      whitePiece: "#F4EAD2",
      blackPiece: "#2A2018",
    },
    },
  },
  [GameVariant.SOUTH_AFRICAN]: {
    code: "rsa",
    variant: GameVariant.SOUTH_AFRICAN,
    cppType: null,
    experimental: false,
    board: {
    shape: "square",
    size: 14,
    playableSquares: "dark",
    piecesPerPlayer: 35,
    initialFen: "W:W64-98:B1-35",
    initialWhite: [64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98],
    initialBlack: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: true,
    menCanCaptureKing: true,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxPieces",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🇿🇦",
    labelKey: "variants.rsa",
    colors: {
      darkSquare: "#6E7A3A",
      lightSquare: "#E9DEBC",
      whitePiece: "#F3ECD2",
      blackPiece: "#262A1C",
    },
    },
  },
  [GameVariant.DAMEO]: {
    code: "dme",
    variant: GameVariant.DAMEO,
    cppType: null,
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "all",
    piecesPerPlayer: 16,
    initialFen: "W:W41-56:B9-24",
    initialWhite: [41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56],
    initialBlack: [9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "orthogonal",
    captureType: "orthogonal",
    winCondition: "normal",
    flyingKings: true,
    menCaptureBackward: false,
    menCanCaptureKing: true,
    mustCaptureMaximum: true,
    captureCompareStrategy: "maxPieces",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: false,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "🎲",
    labelKey: "variants.dme",
    colors: {
      darkSquare: "#6A5E84",
      lightSquare: "#E6E2EC",
      whitePiece: "#F2F0F5",
      blackPiece: "#25222C",
    },
    },
  },
  [GameVariant.CRODA]: {
    code: "cro",
    variant: GameVariant.CRODA,
    cppType: null,
    experimental: false,
    board: {
    shape: "square",
    size: 8,
    playableSquares: "all",
    piecesPerPlayer: 16,
    initialFen: "W:W41-56:B9-24",
    initialWhite: [41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56],
    initialBlack: [9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24],
    initialKingsWhite: [],
    initialKingsBlack: [],
    startingColor: "W",
    blackStarts: false,
    },
    rules: {
    movement: "diagonal",
    captureType: "diagonal",
    winCondition: "normal",
    flyingKings: false,
    menCaptureBackward: true,
    menCanCaptureKing: true,
    mustCaptureMaximum: false,
    captureCompareStrategy: "none",
    preferKingCaptureOnTie: false,
    compareCaptureSequence: false,
    manCaptureValue: 1,
    kingCaptureValue: 2,
    huffing: false,
    promotionStopsCapture: true,
    drawMoveLimit: 0,
    blockedKingMaxMoves: 0,
    frisianEndgameDraws: false,
    promoteInPassing: false,
    removesCapturedImmediately: false,
    forbidCaptureReversal: false,
    loneKingVsLoneManWins: false,
    singlePieceLoses: false,
    },
    ui: {
    darkSquareBottomRight: false,
    flagEmoji: "♟️",
    labelKey: "variants.cro",
    colors: {
      darkSquare: "#6E6E66",
      lightSquare: "#E0E0DA",
      whitePiece: "#F1F1EC",
      blackPiece: "#232320",
    },
    },
  },
};

export const ALL_VARIANT_SPECS: readonly VariantSpec[] = Object.values(VARIANT_SPECS);

export const VARIANT_SPECS_BY_CODE: Readonly<Record<VariantCode, VariantSpec>> =
  Object.fromEntries(ALL_VARIANT_SPECS.map(s => [s.code, s])) as Record<VariantCode, VariantSpec>;

export const NON_EXPERIMENTAL_VARIANTS: readonly VariantSpec[] =
  ALL_VARIANT_SPECS.filter(s => !s.experimental);
